import { isAction } from './isAction'

export type PayloadAction<P = void, T extends string = string> = {
  payload: P
  type: T
}

export const createAction = <P = void>(type: string) => {
  const actionCreator = (payload: P): PayloadAction<P> => {
    return { type, payload }
  }

  actionCreator.toString = () => `${type}`

  actionCreator.type = type

  actionCreator.match = (action: unknown): action is PayloadAction =>
    isAction(action) && action.type === type

  return actionCreator
}
